module.exports = __webpack_public_path__ + "static/media/mark-finn.4c3a3362.jpg";